// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function box6_viewportEnter(event, $w) {

}

export function box6_viewportLeave(event, $w) {
	$w("#logoSmall").show("FadeIn");
}